import React from 'react';
import { Link } from 'react-router-dom';
import ScrollspyNav from './scrollSpy';
import { useTranslation } from 'react-i18next';

const Navbar = () => {

    const { t, i18n } = useTranslation()

    const changeLanguageEnglish = (event) => {
        console.log('The link was clicked.');
        i18n.changeLanguage("en")
        console.log(i18n.language)

    }
    
    const changeLanguageFinnish = (event) => {
        console.log('The link was clicked. Finish');
        i18n.changeLanguage("fi-FI")
        console.log(i18n.language)
    }

    const changeLanguageSwedish = (event) => {
        console.log('The link was clicked. Finish');
        i18n.changeLanguage("se-SE")
        console.log(i18n.language)
    }
    
    const goToLogin = (event) => {

        if(i18n.language == "fi-FI")
            window.location = "https://jrinvoice.com/fi/login"
        else if(i18n.language == "se-SE")
            window.location = "https://jrinvoice.com/sv/login"
        else
            window.location = "https://jrinvoice.com/en/login"

    }

    return (
        <React.Fragment>
            <nav id="main_navbar" className="navbar navbar-expand-lg  fixed-top navbar-custom sticky sticky-dark">
                <div className="container">
                    <Link className="navbar-brand logo" to="/">
                        
                        <div className="text-white text-uppercase jrin">JR INVOICE</div> 
                    </Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="mdi mdi-menu"></i>
                    </button>


                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ScrollspyNav
                            scrollTargetIds={["home", "about", "features", "pricing", "contact"]}
                            activeNavClass="active"
                            scrollDuration="800"
                            headerBackground="true"
                            className="ml-auto">
                            <ul className="navbar-nav ml-auto navbar-center" id="mySidenav">
                                <li className="nav-item active"><a href="#home" className="nav-link">{t('start.label')}</a></li>
                                <li className="nav-item"><a href="#about" className="nav-link">{t('about.label')}</a></li>
                                <li className="nav-item"><a href="#features" className="nav-link">{t('features.label')}</a></li>
                                <li className="nav-item"><a href="#pricing" className="nav-link">{t('pricing.label')}</a> </li>
                        
                                
                                <li className="nav-item"><a href="#contact" className="nav-link">{t('contact.label')}</a> </li>

                                <li className="nav-item dropdown">
                                    
                                    <a href="#" id="drop1" className="nav-link " data-toggle="dropdown">
                                       
                                        {i18n.language === "en" ? (t('english.label')) : null}
                                        {i18n.language === "se-SE" ? (t('swedish.label')) : null}
                                        {i18n.language === "fi-FI" ? (t('finnish.label')) : null}                                       
                                        
                                    </a> 
                                
                                    <ul class=" dropdown-menu">
                                             <li className="text-black"><a href="#" className="text-black" value="fi-FI" onClick={changeLanguageSwedish}>Svenska</a></li>
                                            <li className="text-black"><a href="#" className="text-black" value="fi-FI" onClick={changeLanguageFinnish}>Suomi</a></li>
                                            <li className="text-black"><a href="#" className="text-black" value="en" onClick={changeLanguageEnglish}>English</a></li>

                                    
                                    </ul>
                                
                                
                                
                                </li>
                                <li className="nav-item"><a href="#" className="nav-link" onClick={goToLogin}>{t('login.label')}</a> </li>

                            </ul>
                        </ScrollspyNav>
                    </div>
                </div>
            </nav>
        </React.Fragment>
    );
    }


export default Navbar;